import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button as RButton, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import Barcode from 'react-barcode';
import T from 'modules/i18n';

class RfPayment extends Component {

	constructor(props) {
		super(props);
		this.state = {
			text: '',
			rf: '',
		}
	}

	componentDidMount() {
		this.formatContent();
	}

	formatContent = () => {
		const formatRf = (rf) => {
			if (!rf)
				return rf;
			const elements = rf.split('').map((d, index) => {
				if (index === 0 || index % 4 !== 0) return d;
				if (index % 8 !== 0) return `<b>${d}`;
				if (index % 8 === 0) return `</b>${d}`;
				return '';
			});
			return elements.join('');
		}

		const { node, values } = this.props;
		const amount = String(parseFloat(values.amount).toFixed(2)).replace('.', '').padStart(11, '0');
		const rf = values.rf ? values.rf + amount : values.rf;

		values.rf = formatRf(values.rf);
		const placeholders = {RF: 'rf', amount: 'amount', duration: 'duration', end_datetime: 'expires'};
		let text = node.content_text;
		Object.entries(placeholders).forEach(([placeholder, variable]) => text = text.replace(`[[${placeholder}]]`, values[variable]));

		this.setState({text, rf})
	}

	componentDidUpdate(prevProps) {
		if (prevProps.node !== this.props.node || prevProps.values !== this.props.values)
			this.formatContent();
	}

	handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.disabled)
      return;
    const { node, round, values, onSubmit } = this.props;
		const formdata = new FormData();
		formdata.append('_method', 'put');
		formdata.append('preview', true);
		formdata.append(node.mname, true);
		onSubmit(formdata);
  }

	render() {
		const { className, node, values, disabled  } = this.props;
		
		if(JSON.parse(node.options).preview === 'true'){
			return (
				<Card className={className}>
					<CardBody>
					<div><b><T>organization</T>:</b> { values.org_name}</div><br/>
						<div><b><T>amount</T>:</b> { values.amount}€</div>
						{ values.is_discount_enabled === 'true' && <div><b><T>discount</T>:</b> {values.discount}</div>}
					</CardBody>
					<Row style={{ marginTop: 10, marginBottom: 10 }}>
              <Col className="d-flex justify-content-end">
                <RButton className='mr-5 btn btn-info' disabled={disabled} onClick={this.handleSubmit}><T>continue</T></RButton>
              </Col>
            </Row>

				</Card>
			)
		}

		return (
			<Card className={className}>
				<CardBody>
					<CardTitle dangerouslySetInnerHTML={{__html: this.state.text}}/>
				</CardBody>
				{ (this.state.rf && this.state.rf !== '') &&
					<CardFooter className="d-flex justify-content-center"><Barcode value={this.state.rf}/></CardFooter>
				}
			</Card>
		);
	}
}

const mapStateToProps = (state) => ({
	round: state.context.round,
});

RfPayment = connect(mapStateToProps)(RfPayment);

export default RfPayment;
